export default __webpack_public_path__ + "static/media/pic1.f9e5b7df.webp";